// Popular Toast Lazy Loading
// Only trigger toast animations when product cards come into view

document.addEventListener('DOMContentLoaded', function() {
  // Immediately trigger toasts that should show right away (main product page)
  document.querySelectorAll('.awo-popular-toast-immediate').forEach(function(toast) {
    toast.classList.add('in-view');
  });

  // Check if Intersection Observer is supported
  if (!('IntersectionObserver' in window)) {
    // Fallback: trigger all remaining toasts immediately
    document.querySelectorAll('.awo-popular-toast-lazy:not(.awo-popular-toast-immediate)').forEach(function(toast) {
      toast.classList.add('in-view');
    });
    return;
  }

  // Create intersection observer for lazy-loaded toasts only
  const toastObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // Add class to trigger animation
        entry.target.classList.add('in-view');
        
        // Stop observing this element once it's been triggered
        toastObserver.unobserve(entry.target);
      }
    });
  }, {
    // Trigger when 50% of the element is visible
    threshold: 0.5,
    // Add some margin to trigger slightly before fully in view
    rootMargin: '50px'
  });

  // Observe only the lazy toast containers (not immediate ones)
  document.querySelectorAll('.awo-popular-toast-lazy:not(.awo-popular-toast-immediate)').forEach(function(toast) {
    toastObserver.observe(toast);
  });
}); 